export enum QuoteLinks {
  EN = 'https://bkbn.com/get-a-quote',
  DE = 'https://bkbn.com/de/get-a-quote',
  FR = 'https://bkbn.com/fr/get-a-quote',
  ES = 'https://bkbn.com/es/get-a-quote',
  NL = 'https://bkbn.com/nl/get-a-quote',
  ALL_PURPOSE = 'https://bkbn.com/get-a-quote',
}
